import { isSilentError, logError, type LogTarget } from '@amazon/vinyl-util'
import { toastError } from '@/components/toast'
import { windowEvents } from '@/util/interaction'

const errorHandlerTarget: LogTarget = {
    logPrefix: 'errorHandler',
}

export function handleError(target: LogTarget, error: unknown): void {
    if (isSilentError(error)) return
    logError(target, error)
    const message = error instanceof Error ? error.message : String(error)
    toastError(message)
}

export function createErrorHandler(target: LogTarget): (error: unknown) => void {
    return (error) => handleError(target, error)
}

export function initializeErrorHandling(): void {
    windowEvents.on('error', (event) => {
        if (!(event.error instanceof Error)) return
        handleError(errorHandlerTarget, event.error)
    })
    windowEvents.on('unhandledrejection', (event) => {
        handleError(errorHandlerTarget, event.reason)
    })
}
